var _defs, _rect, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path2, _ellipse5, _ellipse6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nat_svg__a",
    x1: 9,
    y1: 18.17,
    x2: 9,
    y2: 1.506,
    gradientTransform: "rotate(45 9 9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#238ab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#2da4c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#3ed3f2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.553,
    y: 2.553,
    width: 12.893,
    height: 12.893,
    rx: 0.591,
    transform: "rotate(-45 9 9)",
    fill: "url(#nat_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9cebff",
    d: "M14.092 10.067l-.358-.358V8.33h-2.857v1.52h1.281L8.94 13.069 5.721 9.85h1.302V8.33H3.885v1.52h.119l-.216.217 4.498 4.498.654-.653.653.653 4.499-4.498z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.977,
    cy: 9.09,
    rx: 1.577,
    ry: 1.585,
    transform: "rotate(-45.121 3.977 9.09)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.977,
    cy: 9.09,
    rx: 0.896,
    ry: 0.905,
    transform: "rotate(-45.061 3.976 9.09)",
    fill: "#86d633"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.014,
    cy: 9.09,
    rx: 1.577,
    ry: 1.585,
    transform: "rotate(-45.121 14.015 9.09)",
    fill: "#fff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.014,
    cy: 9.09,
    rx: 0.896,
    ry: 0.905,
    transform: "rotate(-45.061 14.015 9.09)",
    fill: "#86d633"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 4.806l-2-2a.15.15 0 00-.213 0l-2 2a.15.15 0 00.106.257h1.135a.107.107 0 01.107.107v10.263H9.7V5.17a.107.107 0 01.1-.107h1.131a.15.15 0 00.109-.257z",
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.935,
    cy: 14.139,
    rx: 1.577,
    ry: 1.585,
    transform: "rotate(-45.121 8.936 14.139)",
    fill: "#fff"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.935,
    cy: 14.139,
    rx: 0.896,
    ry: 0.905,
    transform: "rotate(-45.061 8.936 14.138)",
    fill: "#86d633"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAxOCI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iOSIgeTE9IjE4LjE3IiB4Mj0iOSIgeTI9IjEuNTA2IiBncmFkaWVudFRyYW5zZm9ybT0icm90YXRlKDQ1IDkgOSkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMyMzhhYjAiLz48c3RvcCBvZmZzZXQ9Ii4xMDkiIHN0b3AtY29sb3I9IiMyZGE0YzgiLz48c3RvcCBvZmZzZXQ9Ii43NzUiIHN0b3AtY29sb3I9IiMzZWQzZjIiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48cmVjdCB4PSIyLjU1MyIgeT0iMi41NTMiIHdpZHRoPSIxMi44OTMiIGhlaWdodD0iMTIuODkzIiByeD0iLjU5MSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDkgOSkiIGZpbGw9InVybCgjYSkiLz48cGF0aCBmaWxsPSIjOWNlYmZmIiBkPSJNMTQuMDkyIDEwLjA2N2wtLjM1OC0uMzU4VjguMzNoLTIuODU3djEuNTJoMS4yODFMOC45NCAxMy4wNjkgNS43MjEgOS44NWgxLjMwMlY4LjMzSDMuODg1djEuNTJoLjExOWwtLjIxNi4yMTcgNC40OTggNC40OTguNjU0LS42NTMuNjUzLjY1MyA0LjQ5OS00LjQ5OHoiLz48ZWxsaXBzZSBjeD0iMy45NzciIGN5PSI5LjA5IiByeD0iMS41NzciIHJ5PSIxLjU4NSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1LjEyMSAzLjk3NyA5LjA5KSIgZmlsbD0iI2ZmZiIvPjxlbGxpcHNlIGN4PSIzLjk3NyIgY3k9IjkuMDkiIHJ4PSIuODk2IiByeT0iLjkwNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1LjA2MSAzLjk3NiA5LjA5KSIgZmlsbD0iIzg2ZDYzMyIvPjxlbGxpcHNlIGN4PSIxNC4wMTQiIGN5PSI5LjA5IiByeD0iMS41NzciIHJ5PSIxLjU4NSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1LjEyMSAxNC4wMTUgOS4wOSkiIGZpbGw9IiNmZmYiLz48ZWxsaXBzZSBjeD0iMTQuMDE0IiBjeT0iOS4wOSIgcng9Ii44OTYiIHJ5PSIuOTA1IiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUuMDYxIDE0LjAxNSA5LjA5KSIgZmlsbD0iIzg2ZDYzMyIvPjxnPjxwYXRoIGQ9Ik0xMS4wNCA0LjgwNmwtMi0yYS4xNS4xNSAwIDAwLS4yMTMgMGwtMiAyYS4xNS4xNSAwIDAwLjEwNi4yNTdoMS4xMzVhLjEwNy4xMDcgMCAwMS4xMDcuMTA3djEwLjI2M0g5LjdWNS4xN2EuMTA3LjEwNyAwIDAxLjEtLjEwN2gxLjEzMWEuMTUuMTUgMCAwMC4xMDktLjI1N3oiIGZpbGw9IiNmZmYiLz48ZWxsaXBzZSBjeD0iOC45MzUiIGN5PSIxNC4xMzkiIHJ4PSIxLjU3NyIgcnk9IjEuNTg1IiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUuMTIxIDguOTM2IDE0LjEzOSkiIGZpbGw9IiNmZmYiLz48ZWxsaXBzZSBjeD0iOC45MzUiIGN5PSIxNC4xMzkiIHJ4PSIuODk2IiByeT0iLjkwNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1LjA2MSA4LjkzNiAxNC4xMzgpIiBmaWxsPSIjODZkNjMzIi8+PC9nPjwvc3ZnPg==";
export { SvgNat as ReactComponent };